/**
 * Sprintf.
 */
window.sprintf = function(format) {
    for (let i = 1; i < arguments.length; i++) {
        format = format.replace(/%s/, arguments[i]);
    }
    return format;
}
